<div class="restart-dialog">
  <div class="dialog-content">
    <div class="icon">
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12 16V12M12 8H12.01M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
          stroke="#000D4D"
          stroke-opacity="0.45"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
    <div class="dialog-text">
      <h3 i18n>Restart Johnny Chat?</h3>
      <p i18n>
        You're about to restart the current chat with Johnny. All previously
        generated progress may be lost. Would you like to proceed?
      </p>
    </div>
  </div>
  <div class="dialog-actions w100">
    <rr-btn type="secondary" tone="brand" i18n (click)="close(false)"
      >Close</rr-btn
    >
    <rr-btn type="primary" tone="brand" i18n (click)="close(true)"
      >Restart Chat</rr-btn
    >
  </div>
</div>
